import { Link } from "react-router-dom";
import { useState } from "react";
import "./LoginV3.css";

export default function LoginV3(): JSX.Element {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <div className="gl-page lvg3">
      <Link to="/" className="lvg3-brand">
        <span className="lvg3-brand-glyph"></span> SubsWall
      </Link>

      <div className="lvg3-shell">
        <div className="lvg3-card gl-card-accent">
          {!sent ? (
            <>
              <div className="gl-eyebrow">Claim your wall</div>
              <h1 className="gl-display lvg3-h1">Welcome.</h1>
              <p className="gl-lead lvg3-lead">
                We'll send you a one-time sign-in link. No passwords, no
                forgotten emails.
              </p>

              <form onSubmit={(e) => { e.preventDefault(); if (email) setSent(true); }}>
                <label className="lvg3-field">
                  <span className="gl-eyebrow">Email</span>
                  <input
                    type="email"
                    autoFocus
                    placeholder="you@channel.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                <button type="submit" className="gl-btn gl-btn-primary lvg3-cta">
                  Send sign-in link →
                </button>
              </form>

              <div className="lvg3-divider"><span>or</span></div>

              <button className="gl-btn gl-btn-ghost lvg3-oauth" disabled>
                <span>▶</span> Continue with YouTube
              </button>
              <button className="gl-btn gl-btn-ghost lvg3-oauth" disabled>
                <span>◆</span> Continue with Twitch
              </button>

              <div className="lvg3-foot">
                By signing in you agree to our <Link to="/terms">Terms</Link>{" "}
                and <Link to="/privacy">Privacy</Link>.
              </div>
            </>
          ) : (
            <>
              <div className="gl-eyebrow">Check your inbox</div>
              <h1 className="gl-display lvg3-h1">Sent to {email}.</h1>
              <p className="gl-lead lvg3-lead">
                Click the link we just sent to finish signing in. Doesn't show up?
                Check spam, or{" "}
                <button type="button" onClick={() => setSent(false)} className="lvg3-resend">
                  try a different email
                </button>.
              </p>
            </>
          )}
        </div>

        <Link to="/" className="lvg3-back">← Back to home</Link>
      </div>
    </div>
  );
}
